<template>
  <div>
    <vs-col type="flex" vs-w="4" vs-lg="2" vs-md="2" vs-xs="12" style="margin-bottom: 20px;" :key="indexData" v-for="(data, indexData) in queues">
      <vs-card class="cardx">
        <div slot="header">
          <vs-row>
            <vs-col vs-w="12" class="text-center">
              <h2>
                <span v-if="data.label && data.label.length > 0" v-text="data.label"/>
                <span v-else v-text="data.number" />
              </h2>
              <vs-divider/>
              <vs-button color="success" type="filled" @click.prevent="viewInfo(data.number)" v-text="$t('view_info')"></vs-button>
            </vs-col>
          </vs-row>
        </div>
      </vs-card>
    </vs-col>
  </div>
</template>

<script>

import ctiWindow from '@/helpers/ctiWindow'

export default {
  name: 'Shared.ObQueueStatus.List',
  props: {
    queues: {
      type: [Object, Array],
      required: true
    }
  },
  methods: {
    viewInfo (queue) {
      if(queue == "5000") {
        ctiWindow.obQueueStatusCdrWindow(queue)
      } else {
        ctiWindow.obQueueStatusWindow(queue)
      }
    }
  }
}
</script>

<style scoped>
.cardx {
  width: calc(100% - 25px);
  margin: 5px;
}
</style>
